export default __webpack_public_path__ + "static/media/project-img-2.6e58cf21.png";